/**
 * Nombre y código del artículo de un renglón del pedido técnico para la celda de dos líneas.
 * @param {Object} articlesByUuid Artículos cargados por UUID.
 * @param {string} articleUuid Artículo del renglón.
 * @returns {{name: string, code: string}}
 */
export const getOrderItemArticleParts = (articlesByUuid, articleUuid) => {
  const article = articlesByUuid[articleUuid];
  if (!article) {
    return { name: articleUuid?.slice(0, 8) || '-', code: '' };
  }
  return { name: article.name, code: article.external_code || article.code || '' };
};
